// File: cgp-breadcrumbs.service.ts
// Author: Joseph M Diaz
// Date: 5/1/2017
// Desc: CGP Breadcrumbs module.
// Other Contributors:

import { Injectable } from '@angular/core';

@Injectable()
export class CgpBreadcrumbsService {
    breadcrumbsComponent;

    show() {
        this.breadcrumbsComponent.show = true;
    }

    hide() {
        this.breadcrumbsComponent.show = false;
    }

    getBreadcrumbs() {
        return this.breadcrumbsComponent.breadcrumbs;
    }

    updateBreadcrumbs(breadcrumbs) {
        this.breadcrumbsComponent.breadcrumbs = breadcrumbs;
    }

    login() {
        this.breadcrumbsComponent.showBreadcrumbs = true;
    }

    logout() {
        this.breadcrumbsComponent.showBreadcrumbs = false;
    }
}
